import { createRouter, createWebHistory } from 'vue-router'
import HomePage from './views/HomePage.vue'
import ContactPage from './views/ContactPage.vue'
import NewsPage from './views/NewsPage.vue'
import NewsDetailPage from './views/NewPage.vue' // 重命名变量，语义更清晰（原 NewPage 改为 NewsDetailPage）
import ProductsPage from './views/ProductsPage.vue'
import ProductPage from './views/ProductPage.vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import AboutCases from './views/AboutCases.vue'
import AboutFactory from './views/AboutFactory.vue'
import IntroducePage from './views/IntroducePage.vue'

const routes = [
  { path: '/', name: 'HomePage', component: HomePage },
  { 
    path: '/about', 
    name: 'AboutPage', 
    children: [
      { path: 'Cases', name: 'AboutCases', component: AboutCases },
      { path: 'factory', name: 'AboutFactory', component: AboutFactory }
    ]
  },
  { path: '/contact', name: 'ContactPage', component: ContactPage },
  // 新闻列表页
  { path: '/news', name: 'NewsPage', component: NewsPage },
  // 公司简介
  { path: '/introduce', name: 'IntroducePage', component: IntroducePage },
  // 商品列表页
  { path: '/products', name: 'ProductsPage', component: ProductsPage },
  // 商品详情页
  { path: '/products/:productId', name: 'ProductDetail', component: ProductPage },
  // 新闻详情页（修正路径，避免和列表页冲突，参数名保持一致）
  {
    path: '/news/detail/:NewsId', // 建议加 detail 层级，更规范
    name: 'NewsDetail',
    component: NewsDetailPage,
    // 关键：开启 props 传参，自动把路由参数转为 props，避免 params 错误
    props: (route) => ({
      NewsId: Number(route.params.NewsId) // 直接转为数字，避免后续类型问题
    })
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0 } // 优化滚动行为
  }
})

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router